import DirectApi from '../../../../directApi';

export function getSalesforceInstanceUrl() {
	return DirectApi.Fetch('salesforce/instance_url').then(response => response);
}
